/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // NPM: Apollo client for handling graphql request.

/*
 * GRAPH
 */
const Index = gql`
  mutation MyMutation($developerAccountId: ID!) {
    DeclineDeveloperAccount(developerAccountId: $developerAccountId) {
      message
      status
    }
  }
`;

/*
 * EXPORTS
 */
export default Index;
